export default function Sass_Certificate() {
  return (
    <div>
      <h1>Sass Certificate</h1>
    </div>
  );
}
